export type LoginView =
  | 'signin'
  | 'forgot-a'
  | 'forgot-b'
  | 'success'
  | 'new-password'
  | 'mfa'
  | 'mfa-setup'
  | 'mfa-select';

export const POLICY_NOTE =
  'Min 8 characters — must include uppercase, lowercase, a number, and a special character.';

export const mapCognitoError = (
  err: { code?: string; name?: string; message?: string },
  view: LoginView,
): string => {
  const code = err?.code || err?.name;
  switch (code) {
    case 'UserNotFoundException':
      if (view === 'forgot-a')
        return 'If that account exists, a code has been sent to the email address on file.';
      return 'Incorrect username or password.';
    case 'NotAuthorizedException':
      return view.startsWith('mfa')
        ? 'This sign-in challenge expired. Start sign-in again.'
        : 'Incorrect username or password.';
    case 'CodeMismatchException':
      return 'The verification code you entered is incorrect. Please check and try again.';
    case 'ExpiredCodeException':
      if (view.startsWith('mfa')) {
        return 'This sign-in challenge expired. Start sign-in again.';
      }
      return 'That code has expired. Please go back and request a new one.';
    case 'InvalidPasswordException':
      return `Password doesn't meet requirements. ${POLICY_NOTE}`;
    case 'LimitExceededException':
      return 'Too many attempts. Please wait a few minutes and try again.';
    default:
      return err?.message || 'An unexpected error occurred. Please try again.';
  }
};
